import { TextValue } from '@shared/interfaces';

export enum ReactionIntervalsEnum {
    LOW,
    MEDIUM,
    HIGH,
}

export const reactionIntervalsInitialLetter: Record<ReactionIntervalsEnum, string> = {
    [ReactionIntervalsEnum.HIGH]: 'order.reaction.interval.high',
    [ReactionIntervalsEnum.MEDIUM]: 'order.reaction.interval.medium',
    [ReactionIntervalsEnum.LOW]: 'order.reaction.interval.low',
};

export const reactionIntervalsTextValues: TextValue[] = [
    { text: reactionIntervalsInitialLetter[ReactionIntervalsEnum.LOW], value: ReactionIntervalsEnum.LOW },
    {
        text: reactionIntervalsInitialLetter[ReactionIntervalsEnum.MEDIUM],
        value: ReactionIntervalsEnum.MEDIUM,
    },
    { text: reactionIntervalsInitialLetter[ReactionIntervalsEnum.HIGH], value: ReactionIntervalsEnum.HIGH },
];
